export default __webpack_public_path__ + "static/media/page_two.4cc9840a.gif";